import { MRT_ColumnFiltersState } from 'mantine-react-table';

export function getLotsStatsFilters(
  filters: MRT_ColumnFiltersState,
  variant: 'total' | 'pending' | 'validated',
): MRT_ColumnFiltersState {
  const statsBase = filters.filter((f) => f.id !== 'is_validated');

  if (variant === 'total') {
    return statsBase;
  }
  if (variant === 'pending') {
    return [...statsBase, { id: 'is_validated', value: false }];
  }
  return [...statsBase, { id: 'is_validated', value: true }];
}
